import { gql } from '@apollo/client';

const GET_FACET = gql`
    mutation getFacetsByCategory($url_key: String!) {
        facetsByCategoryUrlKey(url_key: $url_key) {
            facets {
                label
                attribute
                coveo_attribute
                facet_intervals
                no_of_intervals
                values
            }
        }
    }
`;
export default GET_FACET;
